export const PRIVACY_POLICY_CONTENT = {
  es: ``,
  en: ``,
};
